module.exports = __webpack_public_path__ + "static/media/noun_Apps_914827.f10a12b4.svg";